import type { Dispatch } from '@reduxjs/toolkit';
import type { BaseAction } from '../@types/actions';

export const SET_LIVE_SHOPPING_REFERENCE = 'SET_LIVE_SHOPPING_REFERENCE';
type SET_LIVESHOPPING_REFERENCE_TYPE = BaseAction<typeof SET_LIVE_SHOPPING_REFERENCE> & {
  reference: string;
};
export const CLEAR_LIVE_SHOPPING_REFERENCE = 'CLEAR_LIVE_SHOPPING_REFERENCE';
type CLEAR_LIVE_SHOPPING_REFERENCE_TYPE = BaseAction<typeof CLEAR_LIVE_SHOPPING_REFERENCE>;

export type LIVESHOPPING_ACTION =
  | SET_LIVESHOPPING_REFERENCE_TYPE
  | CLEAR_LIVE_SHOPPING_REFERENCE_TYPE;

export const setLiveshoppingReference = (reference: string) => (dispatch: Dispatch) =>
  dispatch({ type: SET_LIVE_SHOPPING_REFERENCE, reference });

export const clearLiveshoppingReference = () => (dispatch: Dispatch) =>
  dispatch({ type: CLEAR_LIVE_SHOPPING_REFERENCE });
